import { actions, rateAsync } from './slices';

export const RatingActions = {
  ...actions,
  rateAsync,
};
